<template>
  <div class="main">
    <Header
      :show="true"
      title="添加水份检测"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="请在骨料货车停留在磅上时进行水份检测"
      />
      <van-form
        ref="create"
        @submit="submit"
      >
        <van-field
          name="车牌号"
          label="车牌号"
          placeholder="请输入车牌号"
          readonly
        >
          <template #input>
            {{ listQuery.plateNumber }}
          </template>
        </van-field>
        <van-field
          readonly
          label="物料名称"
          :value="listQuery.materialName"
          placeholder="自动获取"
        />
        <van-field
          clickable
          name="picker"
          :value="listQuery.identifyName"
          label="核对物料"
          placeholder="点击选择物料名称"
          required
          :rules="[{ validator: validCheckMaterialName, message: '' }]"
          @click="material.show = true"
        />
        <van-popup
          v-model="material.show"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="material.columns"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
        </van-popup>
        <van-field
          name="检测照片"
          label="检测照片"
          required
        >
          <template #input>
            <van-uploader
              v-model="listQuery.qcPhoto"
              :max-count="1"
              capture="camera"
              :before-read="beforeRead"
              :after-read="afterRead"
              :before-delete="beforeDelete"
            />
          </template>
        </van-field>
        <van-field
          name="含水量"
          label="含水量"
          required
          center
        >
          <template #input>
            <van-stepper
              v-model="listQuery.waterPercent"
              step="0.05"
              min="0"
              max="100"
              :decimal-length="2"
              input-width="80px"
              button-size="28px"
            />
          </template>
          <template #button>
            <img
              src="@/assets/svg/iconBusinessShuiFenJianCeHanLiang.svg"
              height="28px;"
              style="float: right"
            >
          </template>
        </van-field>
        <van-field
          name="rate"
          label="质量评价"
          required
        >
          <template #input>
            <van-rate v-model="listQuery.quality" />
          </template>
        </van-field>
        <van-field
          v-model="listQuery.remark"
          rows="2"
          autosize
          label="备注"
          type="textarea"
          maxlength="100"
          placeholder="请输入备注"
          show-word-limit
        />
        <van-image-preview
          v-model="aiPhotoShow"
          :images="aiPhotoList"
        >
          <template #index>
            AI识别照片
          </template>
        </van-image-preview>
        <div
          v-if="checkPermission([22])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { parseTime } from "@/utils";
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import {
  isUserName,
  isPassword,
  isChinese,
  isPhone,
  isEmail,
} from "@/utils/validate.js";
import { getList as getMaterialList } from "@/api/material.js";
import { updateOne } from "@/api/water.js";

export default {
  name: "ServiceBusinessWaterCreate",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      loading: false,
      isLoading: false,
      listQuery: {
        id: null,
        file: null,
        plateNumber: "",
        materialName: "",
        identifyName: "",
        qcPhoto: [],
        waterPercent: 0.0,
        quality: 1,
        remark: "",
        AIMaterial: "",
        AIMaterialUrl: "",
        status: false,
      },
      aiPhotoShow: false,
      aiPhotoList: [],
      material: {
        show: false,
        columns: [],
      },
    };
  },
  created() {
    const row = this.$route.query;
    this.listQuery.id = row.serial;
    this.listQuery.plateNumber = row.plateNumber;
    this.listQuery.materialName = row.material;
    this.listQuery.AIMaterial = row.AIMaterial;
    this.listQuery.AIMaterialUrl = row.AIMaterialUrl;
    this.aiPhotoList.push(row.AIMaterialUrl.split("------"));
    this.listQuery.status = false;
    if (row.material.indexOf(row.AIMaterial) > -1) {
      this.listQuery.identifyName = row.material;
    } else {
      this.listQuery.identifyName = "";
    }
    this.handleGetMaterialList();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleClickRight() {
      this.$refs.create.submit();
    },
    submit() {
      if (this.listQuery.file === null) {
        showPhoneAlarm(true, "toast", null, 2000, 200, "", "质检照片不能为空");
        return;
      }
      if (this.listQuery.waterPercent < 0) {
        showPhoneAlarm(true, "toast", null, 2000, 200, "", "含水量不能小于零");
        return;
      }
      if (this.listQuery.waterPercent > 99.999) {
        this.listQuery.status = false;
        if (this.listQuery.remark === "") {
          showPhoneAlarm(true, "toast", null, 2000, 300, "", "请说明退货理由");
          return;
        }
      } else {
        this.listQuery.status = true;
      }
      let data = new FormData();
      data.append("id", this.listQuery.id);
      data.append("identifyName", this.listQuery.identifyName);
      data.append("qcPhoto", this.listQuery.file);
      data.append("quality", this.listQuery.quality);
      data.append("waterPercent", this.listQuery.waterPercent);
      data.append("passed", this.listQuery.status);
      data.append("remark", this.listQuery.remark);
      if (this.listQuery.status === false) {
        Dialog.confirm({
          title: "确认退货？",
          message: "物料名称：" + this.listQuery.materialName,
          theme: "round-button",
        })
          .then(() => {
            this.loading = true;
            updateOne(data)
              .then((response) => {
                const { data } = response;
                if (
                  showPhoneAlarm(
                    true,
                    "toast",
                    null,
                    2000,
                    data.code,
                    "水份检测",
                    data.message
                  )
                ) {
                  console.log(data);
                }
                this.loading = false;
              })
              .catch(function (error) {
                this.loading = false;
                console.error(error);
              });
          })
          .catch(() => {
            showPhoneAlarm(true, "toast", "success", 2000, 200, "退货", "取消");
          });
      } else {
        updateOne(data)
          .then((response) => {
            const { data } = response;
            this.loading = true;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "水份检测",
                data.message
              )
            ) {
              this.$router.push({ path: "/service/business/water", query: {} });
            }
            this.loading = false;
          })
          .catch(function (error) {
            this.loading = false;
            console.error(error);
          });
      }
    },
    beforeRead(file) {
      if (file.type !== "image/jpeg") {
        showPhoneAlarm(
          true,
          "toast",
          "success",
          2000,
          200,
          "图片上传",
          "请上传 jpg 格式图片"
        );
        return false;
      }
      return true;
    },
    afterRead(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          this.listQuery.file = file.file;
          resolve(file);
        }
        const scale = parseFloat(
          1 / (file.file.size / 1024 / 1024 / 0.2)
        ).toFixed(2);
        imageConversion
          .compressAccurately(file.file, {
            size: 200,
            // scale: scale,
            width: 640,
          })
          .then((res) => {
            this.listQuery.file = res;
            resolve(res);
          });
      });
    },
    beforeDelete(file) {
      this.listQuery.file = null;
      return true;
    },
    handleMaterialSelect(value) {
      console.log(value);
      this.listQuery.identifyName = value;
      this.material.show = false;
    },
    handleGetMaterialList() {
      const data = {
        page: 1,
        limit: 10000,
      };
      getMaterialList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.material.columns = [];
            for (let i = 0; i < items.length; i++) {
              this.material.columns.push(items[i].name);
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
